// FA-2: the app's calls for a trip's flight (migration 237). The database checks who may do what.

export const FLIGHT_DETAIL_COLUMNS = [
    'engagement_id', 'flight_number', 'flight_airline', 'flight_direction', 'airport_code', 'flight_terminal_type',
    'flight_terminal_type_source', 'flight_status', 'flight_scheduled_time', 'flight_revised_time', 'flight_delay_minutes',
    'flight_suggested_pickup_at', 'flight_suggestion_status', 'flight_suggestion_reason', 'flight_suggestion_change_minutes',
    'flight_last_polled_at', 'flight_tracking_stop_reason',
].join(', ');

/** Writes (or clears, with capture = null and a known flight) the trip's structured flight fields. */
export async function saveTripFlight(client, engagementId, capture) {
    if (!engagementId || capture === undefined) return null;
    const { data, error } = await client.rpc('fa2_capture_trip_flight', {
        p_engagement: engagementId,
        p_capture: capture || { flight_number: null, direction: null, airport_code: null, terminal_type: null },
    });
    if (error) throw new Error(`The flight could not be saved: ${error.message}`);
    return data;
}

/** engagement id -> flight detail row, for the trip cards. A missing table/column (not deployed yet) is an empty map. */
export async function loadFlightDetails(client, engagementIds) {
    const ids = [...new Set((engagementIds || []).filter(Boolean))];
    if (!ids.length) return {};
    try {
        const { data, error } = await client.from('dispatch_engagement_details').select(FLIGHT_DETAIL_COLUMNS).in('engagement_id', ids);
        if (error || !Array.isArray(data)) return {};
        return Object.fromEntries(data.filter((row) => row?.flight_number).map((row) => [row.engagement_id, row]));
    } catch {
        return {};
    }
}

export async function applyFlightSuggestion(client, engagementId) {
    const { data, error } = await client.rpc('fa2_apply_flight_suggestion', { p_engagement: engagementId });
    if (error) throw new Error(error.message);
    return data;
}

export async function dismissFlightSuggestion(client, engagementId) {
    const { data, error } = await client.rpc('fa2_dismiss_flight_suggestion', { p_engagement: engagementId });
    if (error) throw new Error(error.message);
    return data;
}
